import { ConversationClientEventName } from './messenger.interface';

export const CONVERSATION_CLIENT_EVENT_NAMES: ReadonlyArray<ConversationClientEventName> = [
  'conversationAdded',
  'conversationJoined',
  'conversationLeft',
  'conversationRemoved',
  'conversationUpdated',
  'participantJoined',
  'participantLeft',
  'participantUpdated',
  'messageAdded',
  'messageRemoved',
  'messageUpdated',
  'tokenAboutToExpire',
  'tokenExpired',
  'typingEnded',
  'typingStarted',
  'pushNotification',
  'userSubscribed',
  'userUnsubscribed',
  'userUpdated',
  'stateChanged',
  'initialized',
  'initFailed',
  'connectionStateChanged',
  'connectionError'
];

export enum ROUTE_PARAM {
  CONVERSATION_ID= 'conversationUniqueId'
}
